import {Col, Radio, Row} from "antd";
import AppText from "../../common/AppText";
import {t} from "../../../services/i18n";
import React, {useEffect, useMemo} from "react";
import CustomTaskDoneCheckbox from "../../common/CustomTaskDoneCheckbox";
import {Colors} from "../../../styles/Colors";
import FormInput from "../../common/FormInput";
import AdvanceSelect from "../../common/AdvanceSelect";
import {
    createdStatusId,
    LEAD_SOURCE_SELECT,
    LEAD_STATUS_SELECT,
    siteFormLeadFieldOptions
} from "../../../services/ConstHelper";
import {isActive} from "../../../services/Helpers";
import {HStack, VStack} from "native-base";
import InfoTooltip from "../../common/InfoTooltip";
import {GlobalStyleAttributes} from "../../../styles/GlobalStyles";
import {useSelector} from "react-redux";
import orderBy from "lodash-es/orderBy";

const SiteLeadFormSettings = (props) => {
    const {values, setFieldValue} = props
    const box = useSelector(state => state.box.box);
    const sourceOptions = useMemo(() => box?.box_sources?.filter(isActive).map(source => ({ value: source.id, label: source.name })), [box])
    const statusOptions = useMemo(() => box?.box_statuses?.filter(isActive).map(status => ({ value: status.id, label: status.name })), [box])
    const spanLength = 12; // 24 = ant design grid system base

    useEffect(() => {
        console.log('values', values)
    }, [values])
    const isDisabled = (field) => {
        return ['first_name'].includes(field);
    }

    return (
        <VStack space={'1.5rem'}>
            <div>
                <Row style={{paddingBlock: '0.5rem', borderBottom: '1px solid #e0e0e0'}}>
                    <Col span={spanLength - 2}>
                        <AppText boldFont>{t('field-name')}</AppText>
                    </Col>
                    <Col span={spanLength + 1} style={{textAlign: 'center'}}>
                        <AppText boldFont>{t('required-lead-field')}</AppText>
                    </Col>
                </Row>
                {siteFormLeadFieldOptions?.map(field => (
                    <Row style={{paddingBlock: '1rem', borderBottom: '1px solid #e0e0e0'}}>
                        <Col span={spanLength - 2}>
                            <AppText>{t(`${field.replaceAll('_', '-')}`)}</AppText>
                        </Col>
                            <Col span={spanLength + 1} style={{display: 'flex', justifyContent: 'center'}}>
                                <CustomTaskDoneCheckbox
                                    onClick={() => {}}
                                    checkedTooltip={isDisabled(field) ? t(`disabled-${field.replaceAll('_', '-')}-tooltip`) : ''}
                                    uncheckedTooltip={isDisabled(field) ? t(`disabled-${field.replaceAll('_', '-')}-tooltip`) : ''}
                                    colors={{primary: Colors.newDesign.mainBlue, primaryBorder: '#E0E0E0', primaryHover: Colors.newDesign.mainBlueHover}}
                                    disabled={isDisabled(field)}
                                    checked={values[field]?.required}
                                    onChange={(e) => {
                                        setFieldValue(`${field}.required`, e.target.checked)
                                    }}
                                />
                            </Col>
                        </Row>
                ))}
            </div>
            <VStack space={'0.5rem'}>
                <HStack alignItems={'center'}>
                    <AppText fontSize={'15px'} boldFont>{t('lead-details')}</AppText>
                    <InfoTooltip title={t('lead-details-info-tooltip')} />
                </HStack>
                <VStack space={'1.5rem'}>
                    {/*STATUS*/}
                    <FormInput containerProps={{ mb: '0' }} width={'100%'} label={t('lead-status')} name={'status_id'}>
                        <AdvanceSelect type={LEAD_STATUS_SELECT} initValue={values.status_id} options={[...statusOptions, {label: t('created'), value: createdStatusId}]} onChange={(select) => setFieldValue(`status_id`, select.value)} menuShouldScrollIntoView={false} dontSort={true}/>
                    </FormInput>
                    {/*SOURCE*/}
                    <FormInput containerProps={{ mb: '0' }} label={t('lead-source')}  name={'source_id'} width={'100%'}>
                        <AdvanceSelect menuShouldScrollIntoView={false} options={sourceOptions} type={LEAD_SOURCE_SELECT} initValue={values.source_id} onChange={(option) => setFieldValue('source_id', option.value ?? null)} />
                    </FormInput>
                    <VStack space={'0.6rem'}>
                        <AppText fontSize={'15px'} boldFont>{t('show-on-site-header')}</AppText>
                        <Radio.Group name={'show-on-site'} onChange={(e) => setFieldValue('show_on_site', e.target.value)} value={values.show_on_site}>
                            <div style={{display: 'flex', flexDirection: 'column', gap: '12px'}}>
                                <Radio value={false} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t(t("dont-show-on-site-option"))}</AppText></Radio>
                                <Radio value={true} size="sm"><AppText fontSize={GlobalStyleAttributes.fonts.standard16}>{t("show-in-site-option")}</AppText></Radio>
                            </div>
                        </Radio.Group>
                    </VStack>
                </VStack>
            </VStack>
        </VStack>
    )

}

export default SiteLeadFormSettings